<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.grade_level')" for="grade_level_id" />
                            <FormSelect
                                id="grade_level_id"
                                v-model="form.grade_level_id"
                                :options="options.grade_levels"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.grade_level_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.letter')" for="letter" />
                            <FormSelect id="letter" v-model="form.letter" :options="options.letters" class="mt-1" />
                            <FormError :value="form.errors.letter" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput id="name" v-model="form.name" name="name" type="text" max="60" class="mt-1" />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.image')" for="image" />
                            <input
                                id="image"
                                @input="form.image = $event.target.files[0]"
                                name="image"
                                type="file"
                                accept="image/*"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.image" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'group'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'patch',
                grade_level_id: this.group.grade_level_id,
                letter: this.group.letter,
                name: this.group.name,
                image: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
    },
};
</script>
